import {getDateFromArray} from '../../../utils/dateUtil'
import {
	FETCH_RECALL_SUMMARY_DATA,
	GET_BUSINESS_DATES,
	SET_BUSINESS_DATE,
	SET_SECURITY,
	SET_SECURITY_OPTIONS,
} from './RecallSummaryActions'
import {IRecallSummaryData} from './RecallSummaryModel'
import moment from 'moment-timezone'

export interface RecallSummary {
	summaryList: IRecallSummaryData[]
	summaryListCopy: IRecallSummaryData[]
	businessDatesList: any[]
	selectedBusinessDate: any
	selectedSecurity: any
	selectedSecurityOptions: any
	businessDateLoading: boolean
	summaryListLoading: boolean
}

const initialState: RecallSummary = {
	summaryList: [],
	summaryListCopy: [],
	businessDatesList: [],
	selectedBusinessDate: null,
	selectedSecurity: null,
	selectedSecurityOptions: [],
	businessDateLoading: false,
	summaryListLoading: false,
}

export function recallSummaryReducer(state = initialState, action: any) {
	switch (action.type) {
		case GET_BUSINESS_DATES.triggered:
			return {...state, businessDateLoading: true}

		case GET_BUSINESS_DATES.succeeded:
			const businessResponseData = action && action.response && action.response.data

			return {
				...state,
				businessDateLoading: false,
				selectedBusinessDate: businessResponseData
					? getDateFromArray(businessResponseData[0]).format('YYYY-MM-DD')
					: moment().format('YYYY-MM-DD'),
				businessDatesList: businessResponseData
					? businessResponseData.map(date => {
							const eachDate = getDateFromArray(date).format('YYYY-MM-DD')
							return {
								key: eachDate,
								value: eachDate,
							}
					  })
					: [],
			}

		case GET_BUSINESS_DATES.failed:
			return {...state, businessDateLoading: false}

		case FETCH_RECALL_SUMMARY_DATA.triggered:
			return {...state, summaryListLoading: true}

		case FETCH_RECALL_SUMMARY_DATA.succeeded:
			const summaryResponseList = action && action.response && action.response.data

			return {
				...state,
				summaryListLoading: false,
				summaryListCopy: summaryResponseList,
				summaryList: summaryResponseList,
			}

		case FETCH_RECALL_SUMMARY_DATA.failed:
			return {...state, summaryList: [], summaryListLoading: false}

		case SET_BUSINESS_DATE:
			return {
				...state,
				selectedBusinessDate: action.payload,
			}

		case SET_SECURITY:
			return {
				...state,
				selectedSecurity: action.payload,
			}

		case SET_SECURITY_OPTIONS:
			return {
				...state,
				selectedSecurityOptions: action.payload,
			}

		default:
			return {
				...state,
			}
	}
}
